import { YesNo, TextField, SectionIntro } from "./fields";
import { Checkbox } from "../../components/ui/checkbox";

export function StepPhysical({ d, set }) {
  return (
    <>
      <SectionIntro title="Physical & Job Requirements" text="All questions are asked with or without reasonable accommodation." />
      <div className="space-y-6">
        <YesNo id="lift_50" label="Are you able to lift, carry, and maneuver packages weighing more than 50 pounds, with or without reasonable accommodation?" value={d.lift_50} onChange={(v) => set("lift_50", v)} />
        <YesNo id="mobility" label="Are you able to repeatedly enter and exit your vehicle, walk, bend, reach, climb stairs, and perform deliveries in changing weather conditions, with or without reasonable accommodation?" value={d.mobility} onChange={(v) => set("mobility", v)} />
        <YesNo id="smartphone" label="Do you have a smartphone capable of running delivery, navigation, communication, and scanning applications?" value={d.smartphone} onChange={(v) => set("smartphone", v)} />
        <YesNo id="use_tech" label="Are you willing to use delivery and navigation technology while performing assigned work?" value={d.use_tech} onChange={(v) => set("use_tech", v)} />
        <YesNo id="service_windows" label="Are you willing to complete scheduled pickups and time-definite deliveries within assigned service windows?" value={d.service_windows} onChange={(v) => set("service_windows", v)} />
      </div>
    </>
  );
}

export const ACKS = [
  ["vehicle_review", "I understand that my vehicle must be reviewed and approved before I can use it for package delivery."],
  ["maintain_docs", "I understand that I must maintain valid registration, insurance, inspection, and other required vehicle documentation."],
  ["approval_depends", "I understand that vehicle approval may depend on the vehicle's condition, cargo capacity, security, and suitability for the assigned work."],
  ["additional_docs", "I understand that I may be required to provide additional documentation or corrected photographs."],
  ["accurate", "I certify that the information submitted in this application is accurate and complete."],
  ["no_guarantee", "I understand that submitting an application does not guarantee employment, assignment, or vehicle approval."],
  ["contact_authorized", "I authorize Integrity Delivered, Inc. to contact me regarding this employment opportunity."],
];

export function StepAcknowledge({ acks, setAck, signature, setSignature, signatureDate, setSignatureDate }) {
  return (
    <>
      <SectionIntro title="Applicant Acknowledgments" text="Please read and check each statement, then sign electronically." />
      <div className="space-y-3">
        {ACKS.map(([k, text]) => (
          <label key={k} className={`flex gap-3 rounded-xl border p-4 cursor-pointer text-sm transition-colors ${acks[k] ? "border-amber-500/60 bg-amber-500/5 text-white" : "border-slate-700 bg-slate-950 text-slate-300"}`}>
            <Checkbox data-testid={`avp-ack-${k}`} checked={!!acks[k]} onCheckedChange={(v) => setAck(k, !!v)} className="mt-0.5" />
            <span>{text}</span>
          </label>
        ))}
      </div>
      <div className="mt-8 grid sm:grid-cols-2 gap-5">
        <TextField id="signature" label="Electronic signature (type your full legal name)" required value={signature} onChange={setSignature} placeholder="Full legal name" className="mt-2 bg-slate-950 border-slate-700 text-white font-serif italic text-lg" />
        <TextField id="signature_date" label="Date" type="date" required value={signatureDate} onChange={setSignatureDate} />
      </div>
      <p className="mt-4 text-xs text-slate-500">By typing your name you agree this constitutes your electronic signature. We do not request a Social Security number, banking information, medical history, or criminal-history details through this application.</p>
    </>
  );
}
